import { LinkProvider } from "@gromia/components/Link";
import { AlertProvider } from "@gromia/components/ui/Alert";
import { HeaderHeightProvider } from "@gromia/components/ui/Header";
import { Provider as MediaProvider } from "@gromia/utils/useMedia";
import { CmsProvider } from "@gromia/utils/useString";
import { Link } from "gatsby";
import React from "react";

function Providers(props: { children: React.ReactElement<any> }) {
  return (
    <HeaderHeightProvider>
      <CmsProvider>
        <LinkProvider value={Link}>
          <MediaProvider>
            <AlertProvider>{props.children}</AlertProvider>
          </MediaProvider>
        </LinkProvider>
      </CmsProvider>
    </HeaderHeightProvider>
  );
}

export function withProviders<T extends {}>(
  WrappedComponent: React.ComponentType<T>,
) {
  const C = (props: T) => (
    <Providers>
      <WrappedComponent {...props} />
    </Providers>
  );

  return C;
}
